module.exports = __webpack_public_path__ + "static/media/Rectangle-blue.4170ef25.png";